import { deleteData, getData, patchData, postData } from '../../../utils/service';
import { DeleteEmploymentEvent, PatchEmploymentEvent, SubmitEmploymentEvent } from './events';
import { Context, EmploymentResponse, GetEmploymentsResponse, Scope } from './types';
import { employmentApiToForm, employmentFormToApi, employmentsApiToForm } from './utils';

export const EMPLOYMENT_ROUTES = {
  get: '/employment',
  post: '/employment',
  patch: '/employment/{id}',
  delete: '/employment/{id}',
};

const ROUTE_NAME = 'employment';

interface EmploymentInput<T> {
  input: {
    context: Context;
    event: T;
  };
}

export const API_CALLS = {
  get: async ({ input }: { input: Scope }): Promise<GetEmploymentsResponse> =>
    await getData(ROUTE_NAME, {
      sort: input.context.sort,
      transformResponse: employmentsApiToForm,
    }),
  create: async ({ input }: EmploymentInput<SubmitEmploymentEvent>): Promise<EmploymentResponse> =>
    await postData(ROUTE_NAME, {
      data: input.event.values,
      transformRequest: employmentFormToApi,
      transformResponse: employmentApiToForm,
    }),
  delete: async ({ input }: EmploymentInput<DeleteEmploymentEvent>) =>
    await deleteData(ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    }),
  patch: async ({ input }: EmploymentInput<PatchEmploymentEvent>): Promise<EmploymentResponse> =>
    await patchData(ROUTE_NAME, {
      pathParams: { id: input.event.values.id?.toString() || '' },
      data: input.event.values,
      transformRequest: employmentFormToApi,
      transformResponse: employmentApiToForm,
    }),
};
